// extracted by mini-css-extract-plugin
module.exports = {"txt":"Textarea_txt__zEQeZ","txtTitle":"Textarea_txtTitle__vAaaZ","txtContent":"Textarea_txtContent__9GPx1","full":"Textarea_full__R3_4n","error":"Textarea_error__73D8v"};